const DEVICE_TOKEN_KEY = "boldd_web_device_token";

export function getOrCreateDeviceToken() {
  if (typeof window === "undefined") return "";

  try {
    const existing = window.localStorage.getItem(DEVICE_TOKEN_KEY);
    if (existing && existing.trim()) return existing.trim();

    const generated =
      typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random()
            .toString(36)
            .slice(2)}`;

    window.localStorage.setItem(DEVICE_TOKEN_KEY, generated);
    return generated;
  } catch (_error) {
    return "";
  }
}
